import _extends from "../../node_modules/@babel/runtime/helpers/esm/extends.es.js";
import generateUtilityClasses from "../../../utils/generateUtilityClasses/generateUtilityClasses.es.js";
import { pickersInputBaseClasses } from "../PickersInputBase/pickersInputBaseClasses.es.js";
import generateUtilityClass from "../../../utils/generateUtilityClass/generateUtilityClass.es.js";
function getPickersInputUtilityClass(slot) {
  return generateUtilityClass("MuiPickersFilledInput", slot);
}
const pickersInputClasses = _extends({}, pickersInputBaseClasses, generateUtilityClasses("MuiPickersInput", ["root", "input"]));
export {
  getPickersInputUtilityClass,
  pickersInputClasses
};
//# sourceMappingURL=pickersInputClasses.es.js.map
